import script from "./ButtonElement.vue?vue&type=script&setup=true&lang=ts"
export * from "./ButtonElement.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__